import { create } from 'zustand';

const useDoctorScheduleStore = create((set, get) => ({
  doctors: [],
  stats: { total_doctors: 0, with_schedule: 0, no_schedule: 0, total_slots_week: 0 },
  filterOptions: { hospitals: [], specialities: [] },
  pagination: { current_page: 1, total_pages: 1, total_count: 0, per_page: 12 },
  translations: {},

  loading: true,
  viewMode: 'list',

  filters: {
    search: '',
    hospital_id: '',
    speciality_id: '',
    day: '',
    source: '',
    has_schedule_only: false,
  },

  setViewMode: (mode) => set({ viewMode: mode }),
  setTranslations: (translations) => set({ translations }),

  setFilter: (key, value) => {
    set((state) => ({
      filters: { ...state.filters, [key]: value },
      pagination: { ...state.pagination, current_page: 1 },
    }));
  },

  setPage: (page) => {
    set((state) => ({ pagination: { ...state.pagination, current_page: page } }));
  },

  fetchData: async () => {
    set({ loading: true });
    const { filters, pagination } = get();
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== '' && value !== false) {
        params.append(key, value);
      }
    });
    params.append('page', pagination.current_page);
    params.append('per_page', pagination.per_page);

    try {
      const response = await fetch(`/api/admin/doctor-schedules?${params}`);
      const data = await response.json();

      set({
        doctors: data.doctors || [],
        stats: data.stats || {},
        filterOptions: data.filters || {},
        pagination: data.pagination || {},
        loading: false,
      });
    } catch (error) {
      console.error('Failed to fetch doctor schedules:', error);
      set({ loading: false });
    }
  },
}));

export default useDoctorScheduleStore;
